import LeanProfileProvider from '@tv2/lib-offspring/api/user/LeanProfileProvider';
import { useProfiles } from '@/api/profiles/useProfiles';
import { useCurrentProfile } from '@/api/user/ProfileProvider';
import React from 'react';

export default function LeanProfileProviderWrapper({ children }: { children: React.ReactNode }) {
  const profile = useCurrentProfile();
  const { actions } = useProfiles();
  return (
    <LeanProfileProvider profile={profile} actions={actions} profiles={profile.profiles}>
      {children}
    </LeanProfileProvider>
  );
}
